export default "__VITE_ASSET__C80bVlaz__"